export default __webpack_public_path__ + "static/media/nft.86253667.png";